import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import GroupDrawer from './GroupDrawer';

interface GroupOutletContext {
    closeTo: string;
    onChanged?: () => void;
}

export default function GroupDrawerRoute() {
    const navigate = useNavigate();
    const { id } = useParams();
    const context = useOutletContext<GroupOutletContext>();
    const closeTo = context?.closeTo ?? '..';

    return (
        <GroupDrawer
            open
            groupId={id ?? null}
            onClose={() => navigate(closeTo)}
            onChanged={() => context?.onChanged?.()}
        />
    );
}
